import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { ReactiveFormsModule } from '@angular/forms';
import { DialogService } from 'primeng/dynamicdialog';
import { CalendarModule } from 'primeng/calendar';
import { InputSwitchModule } from 'primeng/inputswitch';
import { DividerModule } from 'primeng/divider';
import { ManagementComponent } from './management.component';
import { ManagementRoutingModule } from './management-routing.module';
import { AreasComponent } from './components/areas/areas.component';
import { CountriesComponent } from './components/countries/countries.component';
import { AreaRegisterModalComponent } from './components/area-register-modal/area-register-modal.component';
import { JobpositionRegisterModalComponent } from './components/jobposition-register-modal/jobposition-register-modal.component';
import { AreaEditModalComponent } from './components/area-edit-modal/area-edit-modal.component';
import { JobpositionEditModalComponent } from './components/jobposition-edit-modal/jobposition-edit-modal.component';
import { CountryRegisterModalComponent } from './components/country-register-modal/country-register-modal.component';
import { CountryEditModalComponent } from './components/country-edit-modal/country-edit-modal.component';
import { CityRegisterModalComponent } from './components/city-register-modal/city-register-modal.component';
import { CityEditModalComponent } from './components/city-edit-modal/city-edit-modal.component';

@NgModule({
  declarations: [
    ManagementComponent,
    AreasComponent,
    CountriesComponent,
    AreaRegisterModalComponent,
    JobpositionRegisterModalComponent,
    AreaEditModalComponent,
    JobpositionEditModalComponent,
    CountryRegisterModalComponent,
    CountryEditModalComponent,
    CityRegisterModalComponent,
    CityEditModalComponent,
  ],
  imports: [
    ManagementRoutingModule,
    SharedModule,
    ReactiveFormsModule,
    CalendarModule,
    InputSwitchModule,
    DividerModule,
  ],
  providers: [DialogService],
})
export class ManagementModule {}
